import React, { useState } from "react";
import SignUp from "../components/SignUp";
import SignIn from "../components/SignIn";
import logo from "../assets/Header/boxLogoWhite.png";
import Footer from "../components/Footer";

const AuthPage = () => {
  const [activeComponent, setActiveComponent] = useState("SignIn");

  const handleActive = () => {
    setActiveComponent(!activeComponent);
    setActiveComponent("SignUp");
  };

  return (
    <div className="auth-container">
      {/* Top Buttons */}
      <div className="auth-upperContainer">
        <div className="auth-buttonContainer">
          <button
            className={
              activeComponent === "SignIn" ? "auth-activeButton" : "auth-button"
            }
            onClick={() => setActiveComponent("SignIn")}
          >
            <h2
              className={
                activeComponent === "SignIn"
                  ? "auth-buttonTextActive"
                  : "auth-buttonText"
              }
            >
              Sign In
            </h2>
          </button>
          <button
            className={
              activeComponent === "SignUp" ? "auth-activeButton" : "auth-button"
            }
            onClick={() => setActiveComponent("SignUp")}
          >
            <h2
              className={
                activeComponent === "SignUp"
                  ? "auth-buttonTextActive"
                  : "auth-buttonText"
              }
            >
              Sign Up
            </h2>
          </button>
        </div>
        <img src={logo} alt="Good-People" className="auth-imageLogo" />
      </div>

      {/* Render Component Based on State */}
      <div className="auth-lowerContainer">
        {activeComponent === "SignIn" && (
          <SignIn onButtonPress={handleActive} />
        )}
        {activeComponent === "SignUp" && <SignUp />}
      </div>
    </div>
  );
};

export default AuthPage;
